<template>
  <div>
    <v-list>
      <template>
        <v-subheader>CẢNH BÁO DỰA TRÊN CÁC SỰ KIỆN</v-subheader>
        <!-- <v-list-tile avatar v-if="selectedVehicle.deviceType == `MT20` || selectedVehicle.deviceType == `MT99`">
          <v-list-tile-content>
            <v-list-tile-title>Tắt máy từ xa</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.cutOffEngine"></v-switch>
          </v-list-tile-action>
        </v-list-tile> -->
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Mở khóa trái phép</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.listenAcc"></v-switch>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Xe bị rung lắc</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.listenVibration"></v-switch>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Di chuyển khỏi vị trí đỗ xe</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.listenMoving"></v-switch>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Cảnh báo ngắt nguồn</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.powerCut"></v-switch>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Cảnh báo bình yếu</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.lowBattery"></v-switch>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Bán kính giới hạn</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-text-field
              mask="####"
              label=">= 200m"
              class="meter"
              v-model="securityConfig.listenMovingDistance"
            ></v-text-field>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
        <v-subheader>CÀI ĐẶT LÁI XE AN TOÀN</v-subheader>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Cảnh báo quá tốc độ</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-switch class="switch" color="primary" v-model="securityConfig.speedLimit"></v-switch>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Giới hạn tốc độ</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-text-field
              mask="###"
              label=">= 40km/h"
              class="meter"
              v-model="securityConfig.maxSpeed"
            ></v-text-field>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>
    <v-btn
      block
      round
      color="success"
      class="btn-submit"
      :loading="isLoading"
      @click="submit()"
    >Cập nhật</v-btn>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'vehicle-security-config',
  data () {
    return {
      isLoading: false,
      securityConfig: {
        vehicleId: '',
        listenVibration: false,
        listenMoving: false,
        listenMovingDistance: 0,
        listenAcc: false,
        alarmWhistle: false,
        alarmEngineCutOff: false,
        doorOpen: false,
        speedLimit: false,
        maxSpeed: 0,
        cutOffEngine: false,
        lowBattery: false,
        powerCut: false
      }
    };
  },
  computed: {
    ...mapGetters(['selectedVehicle'])
  },
  watch: {
    selectedVehicle () {
      this.getSecurityConfig(this.selectedVehicle.id).then(res => {
        this.securityConfig = res;
      });
    }
  },
  created () {
    if (this.selectedVehicle) {
      this.getSecurityConfig(this.selectedVehicle.id).then(res => {
        this.securityConfig = res;
      });
    }
  },
  methods: {
    ...mapActions(['getSecurityConfig', 'updateSecurityConfig']),
    submit () {
      this.isLoading = true;
      this.securityConfig.vehicleId = this.selectedVehicle.id;
      this.updateSecurityConfig(this.securityConfig)
        .then(_ => {
          this.isLoading = false;
          this.$emit('show', false);
          window.getApp.showMessage('Cập nhật thành công');
        })
        .catch(_ => {
          this.isLoading = false;
          window.getApp.showMessage(
            'Cập nhật thất bại, vui lòng thử lại',
            'error'
          );
        });
    }
  }
};
</script>
<style scoped>
.switch {
  margin-top: 10px;
}
.v-list__tile__action {
  margin-right: -16px;
}
.btn-submit {
  max-width: 96%;
  margin-left: 2%;
  margin-bottom: 12px;
}
.meter {
  width: 100px;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/SecurityConfig.vue